import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsViewsByTagQuery } from "../graphql/queries";
import type {
  AnalyticsViewsByTagQueryType,
  AnalyticsViewsByTagQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsViewsByTagQuery = (
  options?: QueryHookOptions<
    AnalyticsViewsByTagQueryType,
    AnalyticsViewsByTagQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsViewsByTagQueryType,
    AnalyticsViewsByTagQueryVariablesType
  >(AnalyticsViewsByTagQuery, options);
};
